import { Modal } from "react-bootstrap";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { projectPrimaryColor, projectLogoLight } from "../../generalConfigs";
import validator from "validator";
import { useLocation, Link } from "react-router-dom";
import { MdOutlineDone } from "react-icons/md";
import { Spinner } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";

export default function ResetPassword() {
  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [userFinished, setUserFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const location = useLocation();
  const { doPasswordReset } = useAuth();
  const token = location.search.replace("?token=", "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (validator.isEmail(emailValue)) {
      if (passwordValue === confirmPasswordValue) {
        let resetPasswordData = await doPasswordReset({
          token,
          email: emailValue,
          password: passwordValue,
          password_confirmation: confirmPasswordValue,
        });
        if (resetPasswordData) {
          let status = resetPasswordData.status;
          if (status === 1) {
            localStorage.clear();
            setUserFinished(true);
            setIsLoading(false);
          } else {
            setErrorMsg(
              "Ocorreu um erro, por favor, verifique os dados e tente novamente."
            );
            setIsLoading(false);
          }
        } else {
          setErrorMsg(
            "Ocorreu um erro desconhecido, por favor, tente novamente."
          );
          setIsLoading(false);
        }
      } else {
        setErrorMsg(
          "As senhas não coincidem, verifique os campos de senha e tente novamente."
        );
        setIsLoading(false);
      }
    } else {
      setErrorMsg("Verifique o campo e-mail e tente novamente.");
      setIsLoading(false);
    }
  };

  if (userFinished) {
    return passwordResetSuccessfully();
  }

  return (
    <Modal size="lg" fullscreen={true} show={true}>
      <div className="bg-dark">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 shadow-lg">
              <div className="hero-wrap d-flex align-items-center rounded-3 rounded-end-0 h-100">
                <div className="hero-mask opacity-9 bg-primary" />
                <div className="hero-bg hero-bg-scroll" />
                <div className="hero-content mx-auto w-100 h-100 d-flex flex-column">
                  <div className="row g-0">
                    <div className="col-11 col-lg-10 mx-auto">
                      <div className="mt-3">{projectLogoLight}</div>
                    </div>
                  </div>
                  <div className={isMobile ? "row g-0 my-3" : "row g-0 my-4"}>
                    <div className="col-11 col-lg-10 mx-auto">
                      <h1 className="text-11" style={{ color: "#e0e0e0" }}>
                        Crie sua nova{" "}
                        <span className="markText-animation">senha</span>{" "}
                      </h1>
                      <p
                        className="text-5 lh-base mb-4"
                        style={{ color: "#e0e0e0" }}
                      >
                        Preencha os campos e insira sua nova senha de acesso à
                        plataforma.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 shadow-lg d-flex align-items-center rounded-3 rounded-start-0"
              style={{
                backgroundColor: "white",
                borderRadius: 10,
              }}
            >
              {isLoading ? (
                loadingSkeleton()
              ) : (
                <div className="container my-auto py-4">
                  <div className="row">
                    <div className="col-11 col-lg-10 mx-auto">
                      <h3 className="text-black text-center mb-3 ">
                        Nova senha
                      </h3>

                      <form className="form" onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label className="form-label text-black">
                            E-mail
                          </label>
                          <input
                            type="email"
                            value={emailValue}
                            onChange={(e) => setEmailValue(e.target.value)}
                            className="form-control"
                            required
                            minLength={7}
                            placeholder="Insira seu e-mail"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label text-black">
                            Nova senha
                          </label>
                          <input
                            type="password"
                            value={passwordValue}
                            onChange={(e) => setPasswordValue(e.target.value)}
                            className="form-control"
                            required
                            minLength={7}
                            placeholder="Insira sua nova senha"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label text-black">
                            Confirme sua nova senha
                          </label>
                          <input
                            type="password"
                            value={confirmPasswordValue}
                            onChange={(e) =>
                              setConfirmPasswordValue(e.target.value)
                            }
                            className="form-control"
                            required
                            minLength={7}
                            placeholder="Confirme sua senha"
                          />
                        </div>

                        <div className="d-grid my-4 d-flex flex-column align-items-center">
                          {errorMsg !== "" && (
                            <span
                              className="my-2"
                              style={{
                                color: "red",
                                textAlign: "center",
                              }}
                            >
                              {errorMsg}
                            </span>
                          )}

                          <button
                            className="btn btn-primary"
                            style={{
                              borderRadius: 10,
                              width: "50%",
                              backgroundColor: projectPrimaryColor,
                            }}
                            type="submit"
                          >
                            Confirmar
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

const passwordResetSuccessfully = () => {
  return (
    <Modal size="lg" fullscreen={true} show={true}>
      <div className="bg-dark">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 shadow-lg">
              <div className="hero-wrap d-flex align-items-center rounded-3 rounded-end-0 h-100">
                <div className="hero-mask opacity-9 bg-primary" />
                <div className="hero-bg hero-bg-scroll" />
                <div className="hero-content mx-auto w-100 h-100 d-flex flex-column">
                  <div className="row g-0">
                    <div className="col-11 col-lg-10 mx-auto">
                      <div className="mt-3">{projectLogoLight}</div>
                    </div>
                  </div>
                  <div className={isMobile ? "row g-0 my-3" : "row g-0 my-4"}>
                    <div className="col-11 col-lg-10 mx-auto">
                      <h1 className="text-11" style={{ color: "#e0e0e0" }}>
                        Alterado com{" "}
                        <span className="markText-animation">sucesso!</span>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 shadow-lg d-flex align-items-center rounded-3 rounded-start-0"
              style={{
                backgroundColor: "white",
                borderRadius: 10,
              }}
            >
              <div className="container my-auto py-4">
                <div className="row">
                  <div className="col-11 col-lg-10 mx-auto">
                    <center>
                      <MdOutlineDone size={28} />
                    </center>
                    <h3 className="text-black text-center my-2">
                      Sua senha foi alterada com sucesso.
                    </h3>
                    <span className="mg-t-20">
                      Agora você pode fazer login utilizando sua nova senha na
                      plataforma.
                    </span>
                    <p className="text-2 text-center text-black mb-0 my-4">
                      <span href="/">
                        <Link to="/login">Fazer login</Link>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const loadingSkeleton = () => {
  return (
    <div className="container my-auto py-4">
      <div className="row">
        <div className="col-11 col-lg-10 mx-auto">
          <h3
            className="text-black text-center mb-3"
            style={{ minHeight: "20vh" }}
          >
            <Spinner animation="border" style={{ marginTop: "20%" }} />
          </h3>
        </div>
      </div>
    </div>
  );
};
